/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Title_FallbackInputs */

const en_job_title_fallback = /** @type {(inputs: Job_Title_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job title`)
};

const de_job_title_fallback = /** @type {(inputs: Job_Title_FallbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellentitel`)
};

/**
* | output |
* | --- |
* | "Job title" |
*
* @param {Job_Title_FallbackInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_title_fallback = /** @type {((inputs?: Job_Title_FallbackInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Title_FallbackInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_title_fallback(inputs)
	return en_job_title_fallback(inputs)
});